module.exports = __webpack_public_path__ + "img/ic_publicity_detail6_2.9d9ab2d1.jpg";